export enum BookingDuration {
  one = 'one',
  two = 'two',
  three = 'three',
  four = 'four'
}
